module.exports = __webpack_public_path__ + "static/media/logo_nedgia_full.20029a75.svg";